import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'wen-icon-angle-up',
  templateUrl: './angle-up.component.html',
  styleUrls: ['./angle-up.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AngleUpIconComponent {}
